import Vue from 'vue'
import Router from 'vue-router'
import {
  Switch
} from 'vant'
import VueSvgGauge from 'vue-svg-gauge'

Vue.use(VueSvgGauge)

Vue.use(Switch)
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: {
        name: 'Home'
      },
      meta: {
        auth: true
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/components/Home'),
      redirect: {
        name: 'DashBoard'
      },
      meta: {
        auth: 'home'
      },
      children: [{
          path: 'report',
          name: 'Report',
          component: () => import('@/components/Report')
        },
        {
          path: 'allExcelData',
          name: 'AllExcelData',
          component: () => import('@/components/AllExcelData')
        },
        {
          path: 'map/:mapId',
          name: 'Map',
          component: () => import('@/components/Map')
        },
        {
          path: 'map2/:mapId',
          name: 'Map2',
          component: () => import('@/components/Map2')
        },
        {
          path: 'detail/:dId',
          name: 'Detail',
          component: () => import('@/components/Detail')
        },
        {
          path: 'dashBoard',
          name: 'DashBoard',
          component: () => import('@/components/DashBoard'),
          meta: {
            auth: 'dashBoard'
          }
        },
        {
          path: 'account',
          name: 'Account',
          component: () => import('@/components/Account')
        },
        {
          path: 'changepwd',
          name: 'Changepwd',
          component: () => import('@/components/Changepwd')
        },
        {
          path: 'boputu/:Equipno/:Equipid',
          name: 'boputu',
          component: () =>import ('@/components/Boputu')
        },
        {
          path: 'newboputu/:Equipno/:Equipid',
          name: 'newboputu',
          component: () =>import ('@/components/Boputu4G')
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      // component: () => import('@/components/MapDemo'),
      component: () => import('@/components/Login')
    },
    {
      path: '/monitoring',
      name: 'Monitoring',
      component: () => import('@/components/Monitoring')
    },
    {
      path: '/monitoring26',
      name: 'Monitoring26',
      component: () => import('@/components/Monitoring26')
    },
    {
      path: '/monitoring128',
      name: 'Monitoring128',
      component: () => import('@/components/Monitoring128')
    },
    {
      path: '/Monitoring5638',
      name: 'Monitoring5638',
      component: () => import('@/components/monitoring1025/Monitoring1025')
      // component: () => import('@/components/Monitoring5638')
    },
    {
      path: '/monitoring77',
      name: 'Monitoring77',
      component: () => import('@/components/Monitoring77')
    },
    {
      path: '/verticalMonitoring',
      name: 'VerticalMonitoring',
      component: () => import('@/components/VerticalMonitoring')
    },
    {
      path: '/verticalMonitoring2',
      name: 'VerticalMonitoring2',
      component: () => import('@/components/VerticalMonitoring2')
    },
    {
      // 宁德998
      path: '/verticalMonitoring998',
      name: 'VerticalMonitoring998',
      component: () => import('@/components/VerticalMonitoring998')
    },
    {
      path: '/monitoringShow',
      name: 'MonitoringShow',
      component: () => import('@/components/MonitoringShow')
    },
    {
      path: '/kanbandemo',
      name: 'Kanbandemo',

      component: () => import('@/components/Kanbandemo')
    },
    {
      path: '/oceanDataMap',
      name: 'OceanDataMap',

      component: () => import('@/components/OceanDataMap')
    },
    {
      path: '/mapFrame/:mapId',
      name: 'MapFrame',
      component: () =>
          import ('@/components/MapFrame')
    },
  ]
})
